import { render } from "./DaftarKontraktual.vue?vue&type=template&id=1123e080"
import script from "./DaftarKontraktual.vue?vue&type=script&lang=js"
export * from "./DaftarKontraktual.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__